import React from 'react';
import styles from './Footer.module.css';

const ConsultUs = ({settings}) => {
  return (
    <div className={styles.consultSection} data-aos="fade-right" data-aos-delay="400">
      <div className={styles.consultContent}>
        <div className={styles.consultHeading}>
          <div className={styles.consultHeadingWrapper}>
            <div className={styles.consultHeadingText}>Consult Us</div>
            <div className={styles.horizontalDivider} />
          </div>
        </div>
        {settings?.contactNumber && (
        <div className={styles.consultContact}>
          <div className={styles.consultIconWrapper}>
            <div className={styles.consultIcon}>
              <img src="/img/bodyshop/white-phone.svg" alt="Phone" className={styles.consultIconImage} />
            </div>
          </div>
          <a href={`tel:${settings?.contactNumber}`}>
          <div className={styles.consultPhone}>
            <div className={styles.consultPhoneInner}>{settings?.contactNumber}</div>
          </div>
          </a>
        </div>
        )}
      </div>
    </div>
  );
};

export default ConsultUs;